module.exports = __webpack_public_path__ + "static/sense-ae7c15664dd01c7087e725801b6c7d97.png";